/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Container, SimpleGrid, Stack, Text, Title, Image, Group, Badge, NativeSelect } from "@mantine/core";
import { IconExternalLink } from "@tabler/icons-react";
import ezyvetLogo from "../assets/ezyvet-logo.png";
import covetrusLogo from "../assets/covetrus-logo.png";
import automation from "../assets/automation.svg";
import { useUserProvider } from "@/utils/UserProvider";
import { useState } from "react";
import { UpdateUserInput, UpdateUserMutation } from "@/API";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { generateClient, GraphQLQuery } from "aws-amplify/api";
import { updateUser } from "@/graphql/mutations";
const client = generateClient();

const Integrations = () => {
    return (
        <Container size={'lg'} h={50} mt={'md'}>
            <Stack>
                <Title order={1}>Integrations</Title>
                <Text size="md" c="dimmed">
                    Enhance your workflow with our official browser extension to seamlessly sync information from Manta Classic to your practice management system. Our proprietary automations help you efficiently transfer information without leaving your PIMS environment.
                </Text>
                <IntegrationSelector />
            </Stack>
            <SimpleGrid my={15} cols={{ base: 1, sm: 2, md: 3 }} spacing="lg">
                <IntegrationTile name="ezyVet" description="Cloud-based PIMS system by IDEXX" image={ezyvetLogo} comingsoon={false} />
                <IntegrationTile name="Pulse" description="Cloud-based PIMS system by Covetrus" image={covetrusLogo} comingsoon={false} />
                <IntegrationTile name="All other cloud-based PIMS" description="Platform agnostic solution" image={automation} comingsoon={null} />
            </SimpleGrid>
            <Text size="md" c="dimmed" my={32}>
                Important note: watch out for other similar services claiming to have integrations - none of these have true direct integrations with most PIMS systems yet.
            </Text>
        </Container>
    );
};

export default Integrations;

const IntegrationTile = ({ name, description, image, comingsoon, }: { name: string; description: string; image: string; comingsoon: boolean | null; }) => {
    return (
        <Card shadow="sm" padding="lg" radius="md" withBorder>
            <Card.Section>
                <Image
                    src={image}
                    fit="contain"
                    height={100}
                    // width={50}
                    alt={name}
                />
            </Card.Section>

            <Group justify="space-between" mt="md" mb="xs">
                <Text fw={500}>{name}</Text>
                {comingsoon === null ? null : comingsoon ? <Badge color="pink">Automations Coming Soon</Badge> : <Badge color="green">Fully Automated</Badge>}
            </Group>

            <Text size="sm" c="dimmed">
                {description}
            </Text>

            <Button fullWidth mt="md" radius="md" leftSection={<IconExternalLink />}
                // disabled={comingsoon}
                onClick={() => window.open("https://chromewebstore.google.com/detail/vetscribe-extension/nhmpefijpbihoabklimikoemhehacahe?authuser=2&hl=en", "_blank")}>
                {/* {comingsoon ? 'Coming soon' : 'Get started'} */}
                Get started
            </Button>
        </Card>
    );
};

const IntegrationSelector = () => {
    const { amplifyUser } = useUserProvider();
    const userSelector = (context: any) => [context.user];
    const { user } = useAuthenticator(userSelector);

    const [PIMS, setPIMS] = useState(amplifyUser.pims || 'Please select your PIMS system');

    const PIMS_LIST = [
        'Please select your PIMS system',
        'Avimark',
        'Cornerstone',
        'DaySmart',
        'Digitail',
        'ezyVet',
        'Impromed',
        'Instinct',
        'Neo',
        'Provet',
        'Pulse',
        'Rhapsody',
        'Shepherd',
        'VETport',
        'WOOFware',
        'Other'
    ];

    return (
        <Group>
            <NativeSelect
                size="md" radius={'md'}
                label="Which PIMS system do you use?"
                description="This will help us prioritize which integrations to build"
                data={PIMS_LIST}
                defaultValue={PIMS}
                // defaultChecked={true}
                onChange={async e => {
                    console.log('PIMS:', PIMS, ' Setting to: ', e.target.value);
                    setPIMS(e.target.value);
                    // set PIMS for amplify user
                    const updatedUser: UpdateUserInput = {
                        id: user.username,
                        _version: amplifyUser._version,
                        pims: e.target.value,
                    };
                    const updateUserResult = await client.graphql<
                        GraphQLQuery<UpdateUserMutation>
                    >({ query: updateUser, variables: { input: updatedUser } });
                    console.log(updateUserResult);
                }}
            />
        </Group>
    );
}